const styles = `::slotted(svg) {
  pointer-events: none;
}

:host {
  outline: none;
}
:host button {
  height: 36px;
  width: 36px;
  border-width: 1px;
  border-style: solid;
  border-radius: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: 0;
  flex: none;
  --goto-icon-color: var(--goto-icon-01);
  --goto-icon-size: 24px;
  color: var(--goto-icon-01);
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-ui-02);
  --goto-icon-color: var(--goto-round-button-icon-color);
}
:host button:hover {
  background-color: var(--goto-hover-secondary);
  border-color: var(--goto-ui-02);
}
:host button:active {
  background-color: var(--goto-pressed-secondary);
  border-color: var(--goto-ui-02);
  box-shadow: none;
}
:host button:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host button:-moz-focusring {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}

:host([variant=primary]) button {
  background-color: var(--goto-interactive-01);
  border-color: var(--goto-interactive-01);
  --goto-icon-color: var(--goto-icon-05);
}
:host([variant=primary]) button:hover {
  background-color: var(--goto-hover-primary);
  border-color: var(--goto-hover-primary);
}
:host([variant=primary]) button:active {
  background-color: var(--goto-pressed-primary);
  border-color: var(--goto-pressed-primary);
  box-shadow: none;
}
:host([variant=primary]) button:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=primary]) button:-moz-focusring {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}

:host([variant=success]) button {
  background-color: var(--goto-success-01);
  border-color: var(--goto-round-button-border-success);
  --goto-icon-color: var(--goto-icon-05);
}
:host([variant=success]) button:hover {
  background-color: var(--goto-hover-success);
  border-color: var(--goto-hover-success);
}
:host([variant=success]) button:active {
  background-color: var(--goto-pressed-success);
  border-color: var(--goto-pressed-success);
  box-shadow: none;
}
:host([variant=success]) button:focus-visible {
  border-color: var(--goto-success-01);
  box-shadow: var(--goto-highlight-success);
}
:host([variant=success]) button:-moz-focusring {
  border-color: var(--goto-success-01);
  box-shadow: var(--goto-highlight-success);
}

:host([variant=danger]) button {
  background-color: var(--goto-danger-01);
  border-color: var(--goto-round-button-border-danger);
  --goto-icon-color: var(--goto-icon-05);
}
:host([variant=danger]) button:hover {
  background-color: var(--goto-hover-danger);
  border-color: var(--goto-hover-danger);
}
:host([variant=danger]) button:active {
  background-color: var(--goto-pressed-danger);
  border-color: var(--goto-pressed-danger);
  box-shadow: none;
}
:host([variant=danger]) button:focus-visible {
  border-color: var(--goto-danger-01);
  box-shadow: var(--goto-highlight-error);
}
:host([variant=danger]) button:-moz-focusring {
  border-color: var(--goto-danger-01);
  box-shadow: var(--goto-highlight-error);
}

:host([variant=primary].disabled:not([inactive])) button,
:host([variant=success].disabled:not([inactive])) button,
:host([variant=danger].disabled:not([inactive])) button {
  cursor: default;
  background-color: var(--goto-disabled-02);
  border-color: transparent;
  --goto-icon-color: var(--goto-disabled-04);
  --goto-icon-color: var(--goto-disabled-04);
}

:host([inactive]:not([disabled])) button {
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-ui-02);
  --goto-icon-color: var(--goto-icon-04);
}
:host([inactive]:not([disabled])) button:hover {
  background-color: var(--goto-hover-secondary);
  border-color: var(--goto-ui-02);
}
:host([inactive]:not([disabled])) button:active {
  background-color: var(--goto-pressed-secondary);
  box-shadow: none;
  border-color: var(--goto-ui-02);
}
:host([inactive]:not([disabled])) button:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([inactive]:not([disabled])) button:-moz-focusring {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}

:host([size=small]) button {
  height: 30px;
  width: 30px;
  --goto-icon-size: 20px;
}

:host([size=large]) button {
  height: 42px;
  width: 42px;
}

:host([size=xlarge]) button {
  height: 48px;
  width: 48px;
}

:host([size=xxlarge]) button {
  height: 54px;
  width: 54px;
  --goto-icon-size: 30px;
}

:host([disabled]) button {
  cursor: default;
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-disabled-04);
  --goto-icon-color: var(--goto-disabled-04);
}
:host([disabled]) button:hover {
  cursor: default;
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-disabled-04);
  --goto-icon-color: var(--goto-disabled-04);
}
:host([disabled]) .content {
  pointer-events: none;
}`; export default styles;